import { lazy } from 'react';

// ----------------------------------------------------------------------

const PayrollAndAllowancesPage = lazy(() => import('../pages/PayrollAndAllowances.page'));

// ----------------------------------------------------------------------

const PayrollRoutes = [
    {
        path: '/human-resources/deductions',
        element: <PayrollAndAllowancesPage />,
        layout: 'default',
        isAuthReq: true,
    },

];

export { PayrollRoutes };
